import React from 'react';
import {MatchedInvoicesRow} from '../../types';
import PopupViewMatches from '../PopupViewMatches/PopupViewMatches';
import {toAbsoluteUrl} from "../../../../../_metronic/_helpers";

export const ViewButtonColumnFormatter = (cellContent: MatchedInvoicesRow) => {
  return cellContent?.isUsed
    ? <img src={toAbsoluteUrl('/media/svg/Checked_green.svg')} height={40} alt="i"/>
    : <PopupViewMatches {...cellContent}/>;
};